<template>
  <div style="position: relative;">
    <vue-p5 v-on="{ setup, mouseclicked }"></vue-p5>  
  </div>
  
</template>
<script>
import VueP5 from 'vue-p5';
import { mapActions } from 'vuex';
export default {
  name : 'show-number-line',
  props : {
    number_line : {
      type : Object
    }
  },
  components : {
    VueP5
  },
  data(){
    return {
      sketch : null,
      number_points_coordinates : {},
      inp_vals : {},
      clicked_circle_margin : 8
    }
  },
  methods : {
    ...mapActions(['updateCurrentAnswer']),
    emitResponses(){
      this.updateCurrentAnswer({key : "number_line", value : { 
        selected : this.number_points_coordinates,
        input : this.inp_vals
      }})
    },
    mouseclicked() {
      // Checking if user clicked any of the number cuts
      let margin_allowed = this.clicked_circle_margin

      let current = {
        x : this.sketch.mouseX,
        y : this.sketch.mouseY
      }

      let any_x_correct = false, any_y_correct = false
      for(let coord_i in this.number_points_coordinates){
        const coord = this.number_points_coordinates[coord_i]
        const min_x_margin = coord.x - margin_allowed
        const max_x_margin = coord.x + margin_allowed
        const min_y_margin = coord.y - margin_allowed
        const max_y_margin = coord.y + margin_allowed

        let is_x_correct = false, is_y_correct = false
        // Check if current X lies between it
        if((current.x >= min_x_margin) && (current.x <= max_x_margin)){
          is_x_correct = true
          any_x_correct = true
        }

        // Check if current Y lies between it
        if((current.y >= min_y_margin) && (current.y <= max_y_margin)){
          is_y_correct = true
          any_y_correct = true
        }

        if(is_x_correct && is_y_correct){
          coord.clicked = !coord.clicked
          let new_coord = Object.assign({}, coord)
          this.$set(this.number_points_coordinates, coord_i, new_coord)
        }
      }

      // If clicked on any point which should have been clicked
      if(any_x_correct && any_y_correct){
        this.setup(this.sketch)
        this.emitResponses()
      }
    },
    plotText(sketch, { text, x,  y, color, size }){
      sketch.noStroke()
      sketch.fill(color)

      sketch.textAlign(sketch.CENTER);
      sketch.textSize(size);
      sketch.textStyle(sketch.BOLD);
      sketch.textAlign(sketch.CENTER, sketch.CENTER);
      
      sketch.text(text, x, y)
    },
    clearSketch(){
      this.sketch.clear()

      // Removing the previous inputs
      let prev_inps = document.getElementsByClassName('number_line_inp')
      for(let inp of prev_inps){
        inp.remove()
      }
    },
    createInputOnLine({ x, y, value }){
      let input = this.sketch.createInput();
      input.size(this.number_line.input_width, this.number_line.input_height)
      input.position(x, y);
      input.class("number_line_inp")
      input.style("font-size", `${this.number_line.text_size}px`)
      input.style("border-width", `${this.number_line.input_border_weight}px`)
      input.style("border-color", `${this.number_line.input_border_color}`)  

      if(this.inp_vals[value]){
        input.value(this.inp_vals[value])
      }

      let _vm = this
      //Adding an input event 
      input.input(function(){
        _vm.inp_vals[value] = this.value()

        // Emitting the responses
        _vm.emitResponses()
      })

      return input 
    },
    setup(sketch){
      if(sketch){
        // let _vm = this
        this.sketch = sketch

        // Removing the whole sketch first
        this.clearSketch()

        let canvas_width = this.number_line.canvas_width
        let canvas_height = this.number_line.canvas_height

        // Drawing the canvas
        sketch.createCanvas(canvas_width,canvas_height)

        let x_margin = this.number_line.x_margin
        let arrow_width = 25
        let y_center = canvas_height/2

        const line_width = canvas_width - (2*x_margin)
        const line_coord = {
          x1 : x_margin,
          y1 : y_center,
          x2 : x_margin+line_width,
          y2 : y_center
        }

        //Setting stroke weight & color
        sketch.strokeWeight(this.number_line.stroke_weight)
        sketch.stroke(this.number_line.line_color)
        
        // Drawing the line
        sketch.line(line_coord.x1, line_coord.y1, line_coord.x2, line_coord.y2)

        // Drawing the left arrows
        sketch.line(line_coord.x1, line_coord.y1, line_coord.x1+(arrow_width/2), y_center-(arrow_width/2)) // Top arrow
        sketch.line(line_coord.x1, line_coord.y1, line_coord.x1+(arrow_width/2), y_center+(arrow_width/2)) // Bottom arrow

        // Drawing the right arrows
        sketch.line(line_coord.x2, line_coord.y2, line_coord.x2-(arrow_width/2), y_center-(arrow_width/2)) // Top arrow
        sketch.line(line_coord.x2, line_coord.y2, line_coord.x2-(arrow_width/2), y_center+(arrow_width/2)) // Bottom arrow

        // Diving the lines into parts
        let start_num = this.number_line.start_num
        let end_num = this.number_line.end_num
        let step = this.number_line.step

        let nos = []
        let current_num = start_num
        // If step is 0 return
        if(!step){
          return
        }
        // return
       
        const is_decimal = step.toString().split(".").length > 1
        const precision = is_decimal ? 10 : 1
        while(current_num <= end_num){
          current_num = (Math.round(current_num*precision))/precision
          nos.push(current_num)
          current_num += step
        }

        //Numbers having arrows
        let arrows = this.number_line.arrows ? this.number_line.arrows : []
        
        //Number options
        let number_options = this.number_line.numbers ? this.number_line.numbers : []

        // Now plotting the numbers
        let no_cuts = nos.length + 1

        for(let i in nos){
          let cut_width = line_width/no_cuts
          let cut_x_coord = line_coord.x1 + (cut_width*(parseInt(i)+1))

          //Setting stroke = 0, i.e., no outline
          sketch.stroke(this.number_line.line_color)
          sketch.strokeWeight(this.number_line.stroke_weight)
          // Drawing the cut line
          sketch.line(cut_x_coord, y_center-(arrow_width/2), cut_x_coord, y_center+(arrow_width/2))

          const val = nos[i]
          // Adding the coordinate into arr for clicking status
          let current_n = parseInt(i)+1
          if(!this.number_points_coordinates[current_n]){
            this.number_points_coordinates[current_n] = {
              x : cut_x_coord, y : y_center, clicked : false, num : val
            }
          }

          // Plotting the number if not input type
          const is_inp = this.number_line.inputs.find(val_inp => val_inp == val)//Checking if input has to be plotted
          if(!is_inp){
            // Plotting the text
            let text_x = cut_x_coord
            let text_y = y_center+this.number_line.text_top_margin
            this.plotText(sketch, { 
              text : val, 
              x : text_x, 
              y : text_y, 
              color : this.number_line.text_color,
              size : this.number_line.text_size,
            })

            
            const number_option_obj = number_options.find(obj => obj.number == val)
            
            if(number_option_obj){
              //Checking if this text is highlighted, then plot a circle around
              if(number_option_obj.is_highlight){
                //Draw a circle
                sketch.noFill()
                sketch.stroke(number_option_obj.highlight_color)
                sketch.strokeWeight(2)
                
                sketch.circle(text_x, text_y-2, this.number_line.text_size+(8*val.toString().length))
              }
            }
            
          }else{
            //Plotting the input
            this.createInputOnLine({
              x : cut_x_coord-(this.number_line.input_width/2), 
              y : y_center+this.number_line.input_top_margin,
              value : val
            })
          }
          
          //Drawing the arrows and its related objects
          const arrow_obj = arrows.find(arrow_obj => arrow_obj.from == val)
          if(arrow_obj){
            sketch.noFill();
            sketch.stroke(arrow_obj.color)
            sketch.strokeWeight(arrow_obj.thickness)
            let arc_step = arrow_obj.step
            let arc_height = cut_width
            let arc_width = cut_width*arc_step
            let arc_x = cut_x_coord+(arc_width/2)
            let arc_y = y_center-20
            sketch.arc(arc_x, arc_y, arc_width, arc_height, sketch.PI, sketch.TWO_PI);
            //Drawing the end arrow
            if(arrow_obj.show_arrow){
              sketch.line(cut_x_coord+arc_width, arc_y, cut_x_coord+arc_width-13, arc_y-7) // Left arrow
              sketch.line(cut_x_coord+arc_width, arc_y, cut_x_coord+arc_width+13, arc_y-7) // Right arrow
            }

            //Plotting the step
            if(arrow_obj.show_step){
              let prepend = (arc_step>=0) ? '+' : '-'
              let text = `${prepend}${Math.abs(arc_step)}`
              this.plotText(sketch, { 
                text, 
                x : arc_x, 
                y : arc_y-(arc_height/2)-30, 
                color : arrow_obj.color,
                size : this.number_line.text_size,
              })
              // sketch.text(arc_step, arc_x, arc_y-arc_height)
              
            }
          }

          // Drawing the circles for clicking the number cuts
          if(this.number_line.allow_select){
            const coord = this.number_points_coordinates[current_n]
            if(coord.clicked){
              sketch.circle(coord.x, coord.y, 2*this.clicked_circle_margin)
            }
          }

        }
      }
    },
  },
  render(h) {
    return h(VueP5, {on: this});
  },
  watch : {
    number_line : {
      handler(){
        this.setup(this.sketch)
      },
      deep : true
    },
  },
  created(){
  }
}
</script>